// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getInvoiceAuditEvents } from '@/audit/api/get-invoice-audit-events';
import { AuditEventListItem } from '@/audit/components/audit-event-list-item';
import { Stack, Typography } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';

interface Props {
  invoiceKey: string;
}

/**
 * Suspends while fetching the audit events for a single invoice and renders
 * them in reverse chronological order using the shared AuditEventListItem.
 */
export function InvoiceAuditList(props: Props) {
  const { data } = useSuspenseQuery({
    queryKey: ['invoice', props.invoiceKey, 'audit'],
    queryFn: () => getInvoiceAuditEvents(props.invoiceKey),
    retry: false,
  });

  if (data.events.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No audit events recorded for this invoice yet
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      {data.events.map((event) => (
        <AuditEventListItem key={event.id} event={event} />
      ))}
    </Stack>
  );
}
